export default __webpack_public_path__ + "static/media/virtual_services_button_en.6b1d9555.png";